export default "\n@import '/vue-components/ce-poc/dist/css/app.css';\n"